module.exports = __webpack_public_path__ + "fonts/1454a71d-cdbb-429c-8092-122f4493e0c7.d0dd63ee.woff";